import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LockFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.42857 10.7857V8.35713C5.42857 6.74689 6.06824 5.2026 7.20685 4.06399C8.34547 2.92537 9.88976 2.28571 11.5 2.28571C13.1102 2.28571 14.6545 2.92537 15.7931 4.06399C16.9318 5.2026 17.5714 6.74689 17.5714 8.35713V10.7857C18.2155 10.7857 18.8332 11.0416 19.2887 11.497C19.7441 11.9525 20 12.5702 20 13.2143V19.2857C20 19.9298 19.7441 20.5475 19.2887 21.003C18.8332 21.4584 18.2155 21.7143 17.5714 21.7143H5.42857C4.78447 21.7143 4.16676 21.4584 3.71131 21.003C3.25587 20.5475 3 19.9298 3 19.2857V13.2143C3 12.5702 3.25587 11.9525 3.71131 11.497C4.16676 11.0416 4.78447 10.7857 5.42857 10.7857ZM15.1429 8.35713V10.7857H7.85714V8.35713C7.85714 7.39099 8.24094 6.46441 8.92411 5.78125C9.60728 5.09808 10.5339 4.71428 11.5 4.71428C12.4661 4.71428 13.3927 5.09808 14.0759 5.78125C14.7591 6.46441 15.1429 7.39099 15.1429 8.35713Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LockFilledIcon.displayName = 'LockFilledIcon';
